import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';

@Component({
  selector: 'app-confirm-profile-popup',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirm-profile-popup.component.html',
  styleUrls: ['./confirm-profile-popup.component.scss'],
})
export class ConfirmProfilePopupComponent implements OnInit, OnDestroy {
  //Flags for EDIT click check
  nameEditIsNotClicked = true;
  roleEditIsNotClicked = true;
  emailEditIsNotClicked = true;
  commConfmEditIsNotClicked = true;

  //Flags for change in form controls
  isNameFormChanged: boolean = false;
  isRoleChanged: boolean = false;
  isEmailFormChanged: boolean = false;

  //Forms for each edit section
  nameForm: FormGroup;
  emailForm: FormGroup;
  alternateEmailForm: FormGroup;

  //Common info
  loginUserInfo: any;
  isSaveComplete: boolean = false;

  //name related:
  // nameRegex =/^[a-zA-Z]+(-|')?[a-zA-Z]+$/;    //previous one
  nameRegex = /^[a-zA-Z]+([-\s'][a-zA-Z]*)*[a-zA-Z]$/;

  //Role related variables
  roleOfUserArray = [];
  chosenRoleofUser = '';
  displayRoleofUser: any;

  //email conset related
  emailConsent = '';
  showAlternateEmailField = false;
  commRadioChanged = false;
  orderConfirmation = '';

  //alternate email id field
  alternateMailId = '';

  //subscriptions
  userDtaaSubscriber: Subscription;
  emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  baseSiteId: any;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private baseSite: BaseSiteService
  ) {}

  ngOnInit(): void {
    this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.formInitialisation();
    this.getUserData();
  }

  getUserData() {
    this.pfService.getUserDataFromDb(null);

    // this.pfService.userData.pipe(take(1))
    this.userDtaaSubscriber = this.pfService.userData.subscribe((userData) => {
      this.loginUserInfo = userData?.res;
      if (this.loginUserInfo) {
        if (userData.id === null) {
          this.setAllFormField();
          this.userRoleGetMethod();
          this.setAlternateEmailForm();
        } else {
          if (userData.id === 'name') {
            this.setNameField();
          } else if (userData.id === 'role') {
            this.userRoleGetMethod();
          } else if (userData.id === 'email') {
            this.setEmailForm();
          } else if (userData.id === 'emailConsent') {
            this.setAlternateEmailForm();
            this.setEmailConsent();
          } else {
            // No Change
          }
        }
      }
    });
  }

  formInitialisation() {
    //Form for firstName, lastName
    this.nameForm = new FormGroup({
      actualFirstName: new FormControl('', [
        Validators.required,
        Validators.pattern(this.nameRegex),
      ]),
      actualLastName: new FormControl('', [
        Validators.required,
        Validators.pattern(this.nameRegex),
      ]),
    });

    //Form for email and confirm email
    this.emailForm = new FormGroup({
      // emailId: new FormControl('', [Validators.required, Validators.email,

      // Validators.pattern('^([A-Za-z0-9\\._-]+)@([A-Za-z0-9\\._-]+)\\.([A-Za-z\\.]{2,8})(\\.[A-Za-z\\.]{2,8})?$')]),
      // confirmEmailId: new FormControl('', [Validators.required,
      // Validators.pattern('^([A-Za-z0-9\\._-]+)@([A-Za-z0-9\\._-]+)\\.([A-Za-z\\.]{2,8})(\\.[A-Za-z\\.]{2,8})?$')]),
      emailId: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.emailRegx),
      ]),
      confirmEmailId: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailRegx),
      ]),
    });

    //For for alternal email and confirm alt email
    this.alternateEmailForm = new FormGroup({
      // alternateEmailId: new FormControl('', [Validators.email,
      // Validators.pattern('^([A-Za-z0-9\\._-]+)@([A-Za-z0-9\\._-]+)\\.([A-Za-z\\.]{2,8})(\\.[A-Za-z\\.]{2,8})?$')]),
      // confirmAlternateEmailId: new FormControl('', [
      //   Validators.pattern('^([A-Za-z0-9\\._-]+)@([A-Za-z0-9\\._-]+)\\.([A-Za-z\\.]{2,8})(\\.[A-Za-z\\.]{2,8})?$')]),
      alternateEmailId: new FormControl('', [
        Validators.email,
        Validators.pattern(this.emailRegx),
      ]),
      confirmAlternateEmailId: new FormControl('', [
        Validators.pattern(this.emailRegx),
      ]),
    });
  }

  // ===============================set field values=======================
  setAllFormField() {
    this.setNameField();
    this.setEmailForm();
    this.setEmailConsent();
  }

  // ===============================Name field functions=======================
  setNameField() {
    this.nameForm.reset();
    let firstName = '';
    let lastName = '';

    if (
      this.loginUserInfo?.firstName !== undefined &&
      this.loginUserInfo?.firstName !== null
    ) {
      firstName = this.loginUserInfo?.firstName;
    }
    if (
      this.loginUserInfo?.firstName !== undefined &&
      this.loginUserInfo?.firstName !== null
    ) {
      lastName = this.loginUserInfo?.lastName;
    }
    this.nameForm.setValue({
      actualFirstName: firstName,
      actualLastName: lastName,
    });
    this.ref.detectChanges();
  }

  editNameField() {
    this.nameEditIsNotClicked = false;
  }

  updateNameField() {
    this.nameEditIsNotClicked = true;
    this.isNameFormChanged = false;
    const params = {
      firstName: this.nameForm.controls['actualFirstName'].value,
      lastName: this.nameForm.controls['actualLastName'].value,
      profileUpdateType: 'NAME',
    };
    //this.updateAllUserDataFields(params, 'name');
  }

  cancelNameUpdate() {
    this.nameEditIsNotClicked = true;
    this.isNameFormChanged = false;
    this.setNameField();
  }

  onNameFormChange(controlName: string) {
    const currentValue = this.nameForm.get(controlName).value;
    let initialValue = '';
    if (controlName === 'actualFirstName') {
      initialValue = this.loginUserInfo?.firstName;
    } else {
      initialValue = this.loginUserInfo?.lastName;
    }

    if (currentValue !== initialValue) {
      this.isNameFormChanged = true;
    } else {
      this.isNameFormChanged = false;
    }
  }

  // ===============================Role field functions=======================

  userRoleGetMethod() {
    this.pfService.getUserRoles();

    this.pfService.userRoles.pipe(take(1)).subscribe((data) => {
      if (data) {
        this.roleOfUserArray = data;
        this.userRoleMapping();
      }
    });
  }

  userRoleMapping() {
    this.roleOfUserArray.forEach((res) => {
      if (
        this.loginUserInfo?.role !== undefined &&
        this.loginUserInfo?.role !== null &&
        res.name === this.loginUserInfo.role
      ) {
        this.chosenRoleofUser = res.code;
        this.displayRoleofUser = res.name;
        this.ref.detectChanges();
      }
    });
  }
  editRoleField() {
    this.roleEditIsNotClicked = false;
  }
  updateRoleField() {
    this.roleEditIsNotClicked = true;
    this.isRoleChanged = false;
    this.roleOfUserArray.forEach((res) => {
      if (res.code === this.chosenRoleofUser) {
        this.displayRoleofUser = res.name;
        this.ref.detectChanges();
      }
    });
    const params = {
      role: this.chosenRoleofUser,
      profileUpdateType: 'ROLE',
    };
    //this.updateAllUserDataFields(params, 'role');
  }
  cancelRoleUpdate() {
    this.roleEditIsNotClicked = true;
    this.isRoleChanged = false;
    this.userRoleMapping();
  }

  onRoleChange() {
    let chosenRoleName = '';

    const objectWithChosenCode = this.roleOfUserArray?.find(
      (obj) => obj.code === this.chosenRoleofUser
    );
    if (objectWithChosenCode) {
      chosenRoleName = objectWithChosenCode.name;
    }

    if (
      chosenRoleName?.toLowerCase() !==
      this.loginUserInfo?.role?.toString().toLowerCase()
    ) {
      this.isRoleChanged = true;
    } else {
      this.isRoleChanged = false;
    }
  }

  // ===========================================Email Functions==============================

  setEmailForm() {
    this.emailForm.reset();
    this.emailForm.patchValue({
      emailId: this.loginUserInfo.email,
      confirmEmailId: this.loginUserInfo.email,
    });
    this.ref.detectChanges();
  }

  cancelEmailUpdate() {
    this.emailEditIsNotClicked = true;
    this.isEmailFormChanged = false;
    this.setEmailForm();
  }
  updateEmailField() {
    const params = {
      email: this.emailForm.controls['emailId'].value,
      confirmEmail: this.emailForm.controls['confirmEmailId'].value,
      profileUpdateType: 'EMAIL',
    };
    //this.updateAllUserDataFields(params, 'email');
    this.emailEditIsNotClicked = true;
    this.isEmailFormChanged = false;
  }
  editEmailField() {
    this.emailEditIsNotClicked = false;
  }

  onEmailFormChange() {
    const currentValue = this.emailForm.get('emailId').value;
    const initialValue = this.loginUserInfo?.email;

    if (currentValue !== initialValue) {
      this.isEmailFormChanged = true;
    } else {
      this.isEmailFormChanged = false;
    }
  }

  // ===========================================Email communication=================
  setEmailConsent() {
    this.emailConsent = this.loginUserInfo?.emailConsent?.toString();
    this.ref.detectChanges();
  }

  onCommRadioChange() {
    if (this.emailConsent !== this.loginUserInfo?.emailConsent?.toString()) {
      this.commRadioChanged = true;
    } else {
      this.commRadioChanged = false;
    }
  }

  // ==========================================Alternate Email===================
  setAlternateEmailForm() {
    this.alternateMailId = this.loginUserInfo.alternateEmail;
    // this.alternateEmailForm.setValue({
    //   alternateEmailId: '',
    //   confirmAlternateEmailId: '',
    // });
    this.alternateEmailForm.setValue({
      alternateEmailId: this.alternateMailId,
      confirmAlternateEmailId: this.alternateMailId,
    });
  }

  getPlaceholder() {
    return `${this.loginUserInfo.alternateEmail || ''}`;
  }
  cancelEmailCommuUpdate() {
    this.commConfmEditIsNotClicked = true;
    this.showAlternateEmailField = false;
    this.commRadioChanged = false;
    this.emailConsent = this.loginUserInfo.emailConsent.toString();

    this.alternateEmailForm.patchValue({
      alternateEmailId: '',
      confirmAlternateEmailId: '',
    });
  }
  deleteAlternateEmailField() {
    this.showAlternateEmailField = false;
    this.alternateEmailForm.patchValue({
      alternateEmailId: '',
      confirmAlternateEmailId: '',
    });
  }

  setValues() {
    this.orderConfirmation =
      this.loginUserInfo.orderConfirmationEmailConsent.toString();
  }

  updateEmailCommunField() {
    const params = {
      alternateEmail: this.alternateEmailForm.get('alternateEmailId').value,
      confirmAlternateEmail: this.alternateEmailForm.get(
        'confirmAlternateEmailId'
      ).value,
      emailConsent: this.emailConsent,
      profileUpdateType: 'EMAIL_CONSENT',
    };
    //this.updateAllUserDataFields(params, 'emailConsent');
    this.commConfmEditIsNotClicked = true;
    this.showAlternateEmailField = false;
    this.commRadioChanged = false;
  }

  showRedBorder(txt) {
    if (txt === 'alternateEmail') {
      if (
        this.alternateEmailForm.get('alternateEmailId').invalid &&
        this.alternateEmailForm.get('alternateEmailId').value.length > 0 &&
        (this.alternateEmailForm.get('alternateEmailId').touched ||
          this.alternateEmailForm.get('alternateEmailId').dirty)
      ) {
        return true;
      }

      return false;
    } else {
      if (
        this.alternateEmailForm.get('confirmAlternateEmailId').invalid &&
        this.alternateEmailForm.get('confirmAlternateEmailId').value.length >
          0 &&
        (this.alternateEmailForm.get('confirmAlternateEmailId').touched ||
          this.alternateEmailForm.get('confirmAlternateEmailId').dirty)
      ) {
        return true;
      } else if (
        this.alternateEmailForm.get('confirmAlternateEmailId').value !=
          this.alternateEmailForm.get('alternateEmailId').value &&
        this.alternateEmailForm.get('confirmAlternateEmailId').value.length >
          0 &&
        (this.alternateEmailForm.get('confirmAlternateEmailId').dirty ||
          this.alternateEmailForm.get('confirmAlternateEmailId').touched)
      ) {
        return true;
      }

      return false;
    }
  }

  checkForValidity() {
    if (this.commRadioChanged && !this.showAlternateEmailField) {
      return false;
    } else if (
      this.showAlternateEmailField &&
      this.alternateEmailForm.get('confirmAlternateEmailId').value &&
      this.alternateEmailForm.get('confirmAlternateEmailId').value ==
        this.alternateEmailForm.get('alternateEmailId').value
    ) {
      return false;
    }
    return true;
  }

  // ========================================UpdateApi==============================

  updateAllUserDataFields(params, id) {
    this.pfService.updateUserData(params);
    this.pfService.userDataUpdate.pipe(take(1)).subscribe(
      (res) => {
        if (res) {
          this.pfService.getUserDataFromDb(id);
        }
      },
      (err) => {}
    );
  }

  saveUserDetails() {
    this.submitForms();
    //save user details api call
    this.isSaveComplete = true; //change it on success api call
  }
  closeModal() {
    this.activeModal.close();
  }

  ngOnDestroy() {
    this.userDtaaSubscriber?.unsubscribe();
  }

  submitForms() {
    const params = {
      uid: this.loginUserInfo.uid,
      firstName: this.nameForm.controls['actualFirstName'].value,
      lastName: this.nameForm.controls['actualLastName'].value,
      role: this.chosenRoleofUser,
      email: this.emailForm.controls['emailId'].value,
      confirmEmail: this.emailForm.controls['confirmEmailId'].value,
      emailConsent: this.emailConsent,
      //alternateEmail: this.alternateEmailForm.get('alternateEmailId').value,
      //confirmAlternateEmail: this.alternateEmailForm.get('confirmAlternateEmailId').value,
      profileUpdateType: 'NAME_EMAIL',
    };
    	this.pfService.updateYearlyUserDetails(this.loginUserInfo.uid, params).subscribe((res) => {
      console.log('ressss', res)
    })
  }
}
